<template>
    <el-row class="not-found">
        <div class="not-found-wrapper">
            <div class="description">
                Упс, страницы не существует
            </div>
            <h1>
                404
            </h1>
            <div class="description">
                Page not found
            </div>
            <div class="img"></div>
            <el-button type="text" @click="$router.push({name: 'home'})" class="btn btn-default orange go-home">
                на главную
            </el-button>
        </div>
    </el-row>
</template>

<script>
export default {
    name: 'Page404Mobile'
};
</script>
